class ScreenAreaTrigger {
    constructor() {
        this.cacheArea = this.currentArea
        this.initListeners()
    }

    initListeners() {
        $(window).on('scroll', this.checkNewArea.bind(this))
    }

    checkNewArea() {
        const area = this.currentArea
        if (this.cacheArea !== area) {
            this.cacheArea = area
            $(window).trigger('screen:change')
        }
    }

    get currentArea() {
        return Math.floor(document.documentElement.scrollTop / window.innerHeight)
    }
}
